import React from 'react';
import { Alert, AlertTitle, Button } from '@mui/material';
import { CloudQueue, Cloud, Login as LoginIcon } from '@mui/icons-material';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

const AuthStatusBanner: React.FC = () => {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();

  if (isAuthenticated) {
    return (
      <Alert 
        severity="success" 
        icon={<Cloud />}
        sx={{ mb: 2, borderRadius: 2 }}
      >
        <AlertTitle>Conectado a la nube</AlertTitle>
        Tus documentos se sincronizan automáticamente con la nube.
      </Alert>
    );
  }

  return (
    <Alert 
      severity="info" 
      icon={<CloudQueue />}
      sx={{ mb: 2, borderRadius: 2 }}
      action={
        <Button 
          color="inherit" 
          size="small" 
          startIcon={<LoginIcon />}
          onClick={() => navigate('/login')}
        >
          Iniciar Sesión
        </Button>
      }
    >
      <AlertTitle>Nube requerida</AlertTitle>
      OECMR funciona como aplicación cloud-first: inicia sesión para crear, ver y gestionar documentos en el sistema de registro backend.
    </Alert>
  );
};

export default AuthStatusBanner; 